import VideoBackground from 'components/video-background'
import textServices from 'services/text-services'
import { AFTERWORK_ASSETS, AFTERWORK_VIDEOS } from '../constants'

// Single-container section (Figma 43:101): the recap video reaches the top
// and a green gradient overlay fuses the header into it — solid green behind
// the copy, fading to transparent over the footage.
const ReviveSection = () => {
  return (
    <section className="afterwork__revive">
      <VideoBackground
        className="afterwork__revive-video"
        src={`${AFTERWORK_ASSETS}/${AFTERWORK_VIDEOS.recap}`}
      />
      <div className="afterwork__revive-overlay" aria-hidden="true" />
      <div className="afterwork__revive-content">
        <h2 className="afterwork__revive-title">
          {textServices.findByText('afterwork/revive/title', 'Revive la experiencia')}
        </h2>
        <p className="afterwork__revive-description">
          {textServices.findByText(
            'afterwork/revive/description',
            'Así se vivieron los mejores momentos de Afterwork CDMX 2026. Prepárate para la próxima edición.'
          )}
        </p>
      </div>
    </section>
  )
}

export default ReviveSection
